<nz-layout class="app-layout">
  <nz-content>
    <div class="inner-content" nz-row>
      <div nz-col nzSpan="8" nzOffset="8" [nzXs]="{span: 24, offset: 0}" [nzSm]="{span: 20, offset: 2}"
           [nzMd]="{span: 14, offset: 5}" [nzLg]="{span: 12, offset: 6}" [nzXl]="{span: 8, offset: 8}">
        <h1 class="main-title">Carvry</h1>
        <div class="auth-form">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </nz-content>
</nz-layout>
